<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
        el-col.pt-5.text-right(:span="15")
          el-button(type="primary" size="mini" @click="$router.go(-1)") 返回
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      div
        el-row.py-3(type="flex" justify="center")
          el-col(:span="22")
            el-row(type="flex" justify="center" :gutter="10")
              el-col(:span="6")
                el-select.w-100(v-model="list.bill_type" filterable placeholder="请选择单据类型" clearable)
                  el-option(v-for="(item,i) in gzyjdjlx" :key="i" :label="item.name" :value="item.code")
              el-col(:span="6")
                el-input.w-100(v-model="list.bill_code" placeholder="请输入单据号" clearable)
              el-col(:span="6")
                el-select.w-100(v-model="list.source_pk_org" filterable placeholder="请选择移交组织" clearable)
                  el-option(v-for="item in purchase_org" :key="item.pk_org" :label="item.name" :value="item.pk_org")
              el-col(:span="6")
                el-date-picker.w-100(v-model="time" type="daterange" align="right" unlink-panels range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions1")
        el-row.py-1(type="flex" justify="center")
          el-col(:span="12")
            el-row(type="flex" justify="center")
              el-col(:span="10")
                el-button(type="primary" @click="search" :loading="loading") 查询
                el-button(@click="clear") 清空
      el-table(:data="data" v-loading="loading" size="mini")
        el-table-column(prop="bill_code" label="单据号" width="150")
        el-table-column(prop="bill_type" label="单据类型" width="120")
        el-table-column(prop="bill_date" label="单据日期" width="140")
        el-table-column(prop="source_name_org" label="采购组织" show-overflow-tooltip)
        el-table-column(prop="source_name" label="采购员" width="100")
        el-table-column(prop="supplier_name" label="供应商" show-overflow-tooltip)
        el-table-column(prop="creator_name" label="创建人" width="100")
        el-table-column(prop="create_date" label="创建时间" width="140")
        el-table-column(prop="approve_name" label="监交人" width="100")
        el-table-column(prop="target_name" label="接收人" width="100")
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)
</template>
<script>
export default {
  data() {
    return {
      h: "",
      loading: false,
      list: {
        begin_date: null,
        end_date: null,
        bill_code: null,
        bill_type: null,
        source: null, //移交人pk
        source_pk_org: null, //移交组织
        target: null, //接收人pk
        page_num: 1,
        page_size: 10,
      },
      count: 0,
      data: [],
      time: "",
      gzyjdjlx: [],
    };
  },
  props: {
    source: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: null,
    },
  },
  methods: {
    clear() {
      this.list.bill_code = null;
      this.list.source_pk_org = null;
      this.list.bill_type = null;
      this.list.begin_date = null;
      this.list.end_date = null;
      this.time = "";
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      if (this.time) {
        this.list.begin_date = this.time[0];
        this.list.end_date = this.time[1];
      } else {
        this.list.begin_date = null;
        this.list.end_date = null;
      }
      this.list.page_num = 1;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    async getList() {
      this.loading = true;
      let res = await this.$api.work_transfer.getTransferObject(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count = res.count;
      }
    },
    initList() {
      let data = this.$route.query;
      if (JSON.stringify(data) != "{}") {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
        if (this.list.begin_date && this.list.end_date) {
          this.time = [this.list.begin_date, this.list.end_date];
        }
      }
    },
    init() {
      this.initList();
      this.getList();
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();
    this.list.source = this.source;
    this.list.target = this.target;
    this.getDefdoc(this, { code: "gzyjdjlx" });
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>